
import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../../../../../../app/app.service';
import { AppUris, CurrentSelection, Customer, Equipment, Family, JobSite, Make, Model, SearchFavorite, SearchItem, SelectionLists } from '../../../../../../app/entities';
import { SetupModelsService } from '../../../../../../app/modules/setup-models/setup-models.service';
import { ManageComponentsService } from '../../../../../../app/modules/manage-components/manage-components.service';
import { MakeViewModel } from '../../../../../../app/modules/manage-components/manage-components.model';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { FavouriteDialogService } from '../../../../../../app/modules/GET_NEW_UI/favourite-dialog/favourite-dialog.service';
import { GenericIdName } from '../../../../../../app/shared/models/common-search-filters.model';
import { SetupEquipmentService } from '../../../../../../app/modules/setup-equipment/setup-equipment.service';
import { ActionQuoteCheck, ActionQuoteDetailId, EquipmentQuoteSummaryVm, UcActionRecommedSearch, UcPlannerTrackQuoteDetailVm } from '../../../../../../app/modules/setup-equipment/setup-equipment.model';
import { NotificationsService } from 'angular2-notifications';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DisplaySettingsPopupComponent } from '../SettingsPopup/display-settings-popup/display-settings-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { SharedService } from '../../../../../../app/shared/services/SharedService';
import { FormControl } from '@angular/forms';
import { TranslateService } from '../../../../../../app/translate';
import moment from 'moment';

@Component({
  selector: 'app-search-action-recommnedation',
  templateUrl: './search-action-recommnedation.component.html',
  styleUrls: ['./search-action-recommnedation.component.scss']
})
export class SearchActionRecommnedationComponent implements OnInit {
  public customerList: Customer[] = [];
  public customerListFliter: Customer[] = [];
  public jobSiteList: JobSite[] = [];
  public jobSiteListFilter: JobSite[] = [];
  familyList: Family[] = [];
  _dropDownFamilyFiltered: Family[];
  MakeViewModel: MakeViewModel[] = [];
  filteredMakeViewModel: MakeViewModel[] = [];
  familyId: number = 0;
  ModelList: Model[] = [];
  customerTitle: string;
  make_auto: number
  model_auto: number
  filerModelList: GenericIdName[];

  filteredCustomers: Observable<Customer[]>;
  filteredJobsites: Observable<JobSite[]>;
  filteredEquipments: Observable<Equipment[]>;
  filteredFamilies: Observable<Family[]>;
  filteredMakes: Observable<Make[]>;
  filteredModels: Observable<Model[]>;
  filteredExaminers: Observable<Customer[]>;
  filteredDealer: Observable<Customer[]>;
  filterMakeModelFamilyForExistingOnly = true;
  StatusId: number;
  BulkStatusId: number;
  QuoteDeatilList: any;


  @ViewChild('customerAutoCompleteInput', { read: MatAutocompleteTrigger })
  customerTrigger: MatAutocompleteTrigger;
  @ViewChild('jobSiteAutoCompleteInput', { read: MatAutocompleteTrigger })
  jobSiteTrigger: MatAutocompleteTrigger;
  @ViewChild('equipmentAutoCompleteInput', { read: MatAutocompleteTrigger })
  equipmentTrigger: MatAutocompleteTrigger;
  @ViewChild('makeAutoCompleteInput', { read: MatAutocompleteTrigger })
  makeTrigger: MatAutocompleteTrigger;
  @ViewChild('familyAutoCompleteInput', { read: MatAutocompleteTrigger })
  familyTrigger: MatAutocompleteTrigger;
  @ViewChild('modelAutoCompleteInput', { read: MatAutocompleteTrigger })
  modelTrigger: MatAutocompleteTrigger;
  @ViewChild('examinerAutoCompleteInput', { read: MatAutocompleteTrigger })
  examinerTrigger: MatAutocompleteTrigger;
  @ViewChild('dealerAutoCompleteInput', { read: MatAutocompleteTrigger })
  dealerTrigger: MatAutocompleteTrigger;

  customerCtrl: FormControl;
  jobsiteCtrl: FormControl;
  equipmentCtrl: FormControl;
  selectedComponentType: number = 0;
  familyCtrl: FormControl;
  makeCtrl: FormControl;
  modelCtrl: FormControl;
  CustomerId: number;
  JobsiteId: number;
  familyTitle: string;
  genericIdList: GenericIdName[] = [];
  genericIdListTable: GenericIdName[] = [];
  makeTitle: string;
  UcPlannerTrackQuoteDetailVm: UcPlannerTrackQuoteDetailVm;
  IsTableShow: boolean;
  FleetTableLoader: boolean;
  UcActionRecommedSearch: UcActionRecommedSearch;
  unitAuto: string;
  Length: number;
  makeid: string;
  statusId: number;
  selectedModels = [];
  selectedModel: number[] = [];
  userLanguage = 'english';
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectionLists: SelectionLists = new SelectionLists();
  selectedJobsiteForInput: JobSite = new JobSite();
  currentSelection: CurrentSelection = new CurrentSelection();
  JobSiteforFleetconfiguration: JobSite = new JobSite()
  HasfavData: boolean
  multipleSelections: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: 'Evaluation X' }];

  internalLimitedJobSites: JobSite[];
  internalLimitedEquipments: Equipment[];
  internalLimitedModels: Model[];
  internalLimitedCustomers: Customer[];
  ActionQuoteCheck: ActionQuoteCheck = new ActionQuoteCheck();
  ActionQuoteDetailId: ActionQuoteDetailId[] = [];
  userFavorites: SearchFavorite[] = [];
  constructor(private _translate: TranslateService, private _dialog: MatDialog, private _notify: NotificationsService, private _sharedService: SharedService, private _planerService: SetupEquipmentService, private _favouriteDialogService: FavouriteDialogService, private _appService: AppService, public _modelService: SetupModelsService, public _componentService: ManageComponentsService,) {

    this.customerCtrl = new FormControl();
    this.jobsiteCtrl = new FormControl();
    this.equipmentCtrl = new FormControl();
    this.familyCtrl = new FormControl();
    this.makeCtrl = new FormControl();
    this.modelCtrl = new FormControl();
  }
  @ViewChild('autoCompleteInput1', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger1: MatAutocompleteTrigger;
  ngOnInit(): void {
    this.statusId=3;
    this._appService.setPageTitle('Search Recommendation');
    this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this.selectionLists.customerList = result; this.internalLimitedCustomers = result; this.customerCtrl.reset(); });
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => { this.selectionLists.jobSiteList = result; this.internalLimitedJobSites = result; this.jobsiteCtrl.reset(); });
    //   this._appService.getFamilyListForSelection(1, 10000).subscribe(result => {
    //     this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
    //         result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    // });
    this._appService.getFamilyListForSelection(1, 10000).subscribe(result => {
      this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    });
    this._appService.getMakeListForSelection(1, 10000).subscribe(result => { this.selectionLists.makeList = this.filterMakeModelFamilyForExistingOnly ? result.filter(m => m.ExistingCount > 0) : result; this.makeCtrl.reset(); });
    this._appService.getModelListForSelection(1, 10000).subscribe(result => {
      this.selectionLists.modelList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m);
      this.internalLimitedModels = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m); this.modelCtrl.reset();
    });

    this._appService.getUserSearchFavorites(2).subscribe(result => {
      this.userFavorites = result;
      if (this.userFavorites.length > 0) {
        this.HasfavData = true;
      }
      //load default Favourite
      var checkDefaultFav = this.userFavorites.filter(f => f.isDefaultFavourite == true)

      if (checkDefaultFav.length > 0) {
        this.getFavorite(checkDefaultFav[0].Id);

      }
      //end code
    }, error => console.log(error), () => { });

    this.filteredCustomers =
      this.customerCtrl.valueChanges
        .startWith(null)
        .map(customerInput => customerInput ? this.filterCustomers(customerInput) : this.resetCustomer());
    this.filteredJobsites = this.jobsiteCtrl.valueChanges
      .startWith(null)
      .map(jobsiteInput => jobsiteInput ? this.filterJobsites(jobsiteInput) : this.resetJobsite());
    // this.filteredEquipments = this.equipmentCtrl.valueChanges
    //     .startWith(null)
    //     .map(equipmentInput => equipmentInput ? this.filterEquipments(equipmentInput) : this.resetEquipment());
    this.filteredFamilies =
      this.familyCtrl.valueChanges
        .startWith(null)
        .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());
    this.filteredMakes =
      this.makeCtrl.valueChanges
        .startWith(null)
        .map(makeInput => makeInput ? this.filterMakes(makeInput) : this.resetMake());
    this.filteredModels =
      this.modelCtrl.valueChanges
        .startWith(null)
        .map(modelInput => modelInput ? this.filterModels(modelInput) : this.resetModel());

    //this.loadAllModelsList();
    //this.LoadEquipmentRecommenation();
    this.LoadActionRecommendedStatus();
  }

  getFavorite(favId: number) {
    this._appService.getFavoriteItems(favId).subscribe(result => {
      this.resetSelection();
      this.multipleSelections.push(...result);
      this.submitSelection();
    }, error => console.error(error));
  }


  resetSelection() {
    this.multipleSelections = [
      { Id: 8, SearchId: 1, SearchStr: '', Title: 'Evaluation A' },
      { Id: 9, SearchId: 1, SearchStr: '', Title: 'Evaluation B' },
      { Id: 10, SearchId: 1, SearchStr: '', Title: 'Evaluation C' },
      { Id: 11, SearchId: 1, SearchStr: '', Title: 'Evaluation X' },
    ];
    this.filteredCustomers = Observable.of(this.selectionLists.customerList);
    this.filteredJobsites = Observable.of(this.selectionLists.jobSiteList);
    this.filteredFamilies = Observable.of(this.selectionLists.familyList);
    this.filteredMakes = Observable.of(this.selectionLists.makeList);
    this.filteredModels = Observable.of(this.selectionLists.modelList);
    this.filteredEquipments = Observable.of(this.selectionLists.equipmentList);
    this.filteredExaminers = Observable.of(this.selectionLists.examinerList);
    this.filteredDealer = Observable.of(this.selectionLists.dealerList);

    this.internalLimitedJobSites = this.selectionLists.jobSiteList;
    this.internalLimitedModels = this.selectionLists.modelList;
    this.internalLimitedEquipments = this.selectionLists.equipmentList;
    this.selectedComponentType = 0;

    this.internalLimitedCustomers = this.selectionLists.customerList;
    this.customerCtrl.reset();
    this.jobsiteCtrl.reset();
    this.makeCtrl.reset();
    this.modelCtrl.reset();
    this.familyCtrl.reset();
  }


  submitSelection(): void {

    this.currentSelection = new CurrentSelection();
    const firstCustomer = this.multipleSelections.find(m => m.Id === 1);
    if (firstCustomer) {
      this.currentSelection.customer.Id = firstCustomer.Id;
      this.currentSelection.customer.Title = firstCustomer.Title;
      this.customerCtrl.setValue(firstCustomer.Title)
      this.CustomerId = firstCustomer.Id;
    }

    const firstJobsite = this.multipleSelections.find(m => m.Id === 2);
    if (firstJobsite) {
      this.currentSelection.jobSite.Id = firstJobsite.Id;
      this.currentSelection.jobSite.Title = firstJobsite.Title;
      this.jobsiteCtrl.setValue(firstJobsite.Title)
      this.JobsiteId = firstJobsite.Id;
    }

    const firstFamily = this.multipleSelections.find(m => m.Id === 4);
    if (firstFamily) {
      this.currentSelection.family.Id = firstFamily.Id;
      this.currentSelection.family.Title = firstFamily.Title;
      this.familyCtrl.setValue(firstFamily.Title)
      this.familyId = firstFamily.Id;
    }
    const firstMake = this.multipleSelections.find(m => m.Id === 5);
    if (firstMake) {
      this.currentSelection.make.Id = firstMake.Id;
      this.currentSelection.make.Title = firstMake.Title;

      this.makeCtrl.setValue(firstFamily.Title)
      this.make_auto = firstFamily.Id;
    }
    const firstModel = this.multipleSelections.find(m => m.Id === 6);
    if (firstModel) {
      this.currentSelection.model.Id = firstModel.Id;
      this.currentSelection.model.Title = firstModel.Title;
    }
  }

  resetModel(): Model[] {
    this.currentSelection.model = new Model();


    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
      return this.selectionLists.modelList.filter(model =>
        this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model =>
        this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);


    return this.selectionLists.modelList.filter(model =>
      this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
      && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);
  }
  resetMake(): Make[] {
    this.currentSelection.make = new Make();
    if (!this.selectionLists.makeList) return [];

    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.modelCtrl.reset();
    return this.selectionLists.makeList.filter(make =>
      (this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === make.Id || m.SearchStr.toLowerCase() === make.Title.toLowerCase())) < 0)
    );

  }
  filterModels(userText: any) {
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      );

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);


    return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
      && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
      && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

  }
  loadFamilyList() {
    this._modelService.getFamilyList().subscribe(result => {
      this.familyList = result;
      this._dropDownFamilyFiltered = result;
    })
  }

  loadAllMakeList() {
    this._componentService.GetMakeFromFamily(this.familyId).subscribe(result => {
      this.MakeViewModel = result;
      this.filteredMakeViewModel = result;
      //this.filteredMakeViewModelMain = result;

    })
  }
  customerChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this.customerListFliter = this.customerList.filter(option => option.Title.toLowerCase().includes(filterValue));
    } else {
    }
  }

  onSelectCustomer(event: any) {
    let id = this.customerListFliter.find(f => f.Title.trim() == event.value.trim()).Id;
    this.CustomerId = id;
    this.customerTitle = event.value;
    this.jobSiteListFilter = this.jobSiteList.filter(jobsite =>
      jobsite.CustomerId == id);
    // this.autoCompleteTrigger1.writeValue('');
  }

  LoadActionRecommendedStatus() {
    this._planerService.GetActionRecommnnededStatus().subscribe(result => {
      this.genericIdList = result;
      this.genericIdListTable = result;
    })
  }

  familySelected(selected, input) {
    this.currentSelection.family.Id = selected.option.value.Id;
    this.currentSelection.family.Title = selected.option.value.Title;
    this.pushMultipleSelection(4, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.familyCtrl.reset();
    this.familyCtrl.setValue(selected.option.value.Title);
  }

  makeSelected(selected, input) {
    this.currentSelection.make.Id = selected.option.value.Id;
    this.currentSelection.make.Title = selected.option.value.Title;

    this.pushMultipleSelection(5, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 4).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.makeCtrl.reset();
    this.makeCtrl.setValue(selected.option.value.Title)
  }

  modelDisplayMapper(model: Model) {
    return model ? model.Title : model;
  }

  familyChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this._dropDownFamilyFiltered = this.familyList.filter(option => option.Title.toLowerCase().includes(filterValue));
    } else {
      this.familyId = 0;
      this.autoCompleteTrigger1.closePanel();
      this.autoCompleteTrigger1.writeValue('');
      this.familyId = 0;
      this.loadFamilyList();
      this.loadAllMakeList();
      this.make_auto = 0;
      this.model_auto = 0;
    }
  }

  onSelectFamily(event: any) {
    let id = this._dropDownFamilyFiltered.find(f => f.Title == event.value.split('|')[0].trim()).Id;
    this.familyId = id;
    this.familyTitle = this._dropDownFamilyFiltered.find(f => f.Title == event.value.split('|')[0].trim()).Title + ' | ' + this._dropDownFamilyFiltered.find(f => f.Title == event.value.split('|')[0].trim()).Symbol
    this.loadAllMakeList();
  }

  MakeChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this.filteredMakeViewModel = this.MakeViewModel.filter(option => option.Makedesc.toLowerCase().includes(filterValue));

    } else {
      this.make_auto = null;
      if (this.familyId != 0) {
        this.loadAllMakeList();
      }
    }
  }

  // Remove model from selected list
  removeModel(model: any): void {
    const index = this.selectedModels.indexOf(model);
    if (index >= 0) {
      this.selectedModel.splice(index, 1);

      this.selectedModels.splice(index, 1);

    }
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  modelSelected(selected, input) {
    if (input)
      input.value = '';
    this.currentSelection.model.Id = selected.option.value.Id;
    this.currentSelection.model.Title = selected.option.value.Title;
    this.pushMultipleSelection(6, selected.option.value.Id, selected.option.value.Title);
    this.modelCtrl.reset();
  }



  openPopuUp(QuoteDetailAuto: number) {
    const dialogRef = this._dialog.open(DisplaySettingsPopupComponent, {
      width: "300px",
      data: {
        PopupFor: 10,
        QuoteDetailAuto: QuoteDetailAuto
      }

    });
    dialogRef.afterClosed().subscribe(edited => {

    });
  }


  getPushedSelections(itemId): SearchItem[] {
    let arr = this.multipleSelections.filter(m => m.Id === itemId);
    return arr
  }

  focus(item) {
    switch (item) {
      case 1:
        this.customerTrigger.openPanel();
        break;
      case 2:
        this.jobSiteTrigger.openPanel();
        break;
      case 3:
        this.equipmentTrigger.openPanel();
        break;
      case 4:
        this.familyTrigger.openPanel();
        break;
      case 5:
        this.makeTrigger.openPanel();
        break;
      case 6:
        this.modelTrigger.openPanel();
        break;
      case 20:
        this.examinerTrigger.openPanel();
        break;
      case 21:
        this.dealerTrigger.openPanel();
        break;
    }
  }


  jobsiteDisplayMapper(jobsite: JobSite) {
    return jobsite ? jobsite.Title : jobsite;
  }
  resetJobsite(): JobSite[] {
    // console.log('resetJobsite', this.internalLimitedJobSites);
    this.currentSelection.jobSite = new JobSite();
    if (!this.internalLimitedJobSites) return [];

    this.equipmentCtrl.reset();
    return this.internalLimitedJobSites.filter(jobsite =>
      (this.multipleSelections.findIndex(m => m.Id === 2 && (m.SearchId === jobsite.Id || m.SearchStr.toLowerCase() === jobsite.Title.toLowerCase())) < 0)
    );
  }
  filterJobsites(userText: any) {
    // console.log('filterJobsites', userText);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.internalLimitedJobSites.filter(jobsite =>
      jobsite.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
      && (this.multipleSelections.findIndex(m => m.Id === 2 && (m.SearchId === jobsite.Id || m.SearchStr.toLowerCase() === jobsite.Title.toLowerCase())) < 0)
    );
  }

  jobsiteSelected(selected, input) {

    this.selectedJobsiteForInput.Id = selected.option.value.Id
    this.currentSelection.jobSite.Id = selected.option.value.Id;
    this.currentSelection.jobSite.Title = selected.option.value.Title;
    this.pushMultipleSelection(2, selected.option.value.Id, selected.option.value.Title);
    this.JobSiteforFleetconfiguration.Id = selected.option.value.Id
    this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);

    this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(equipment =>
      this.multipleSelections.findIndex(m => m.Id === 2 && (equipment.JobSiteId === m.SearchId)) >= 0);
    this.filteredEquipments = Observable.of(this.internalLimitedEquipments);


    var customerData = this.multipleSelections.find(x => x.Id == 1);
    let customerid = 0;
    if (customerData != null) {
      customerid = customerData.SearchId;
    }

    var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
    let jobsiteid = 0;
    if (jobSiteData != null) {
      jobsiteid = jobSiteData.SearchId;
    }

    this._appService.getFamilyList(customerid.toString(), jobsiteid.toString()).subscribe(result => {
      this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    });

    this.filteredFamilies =
      this.familyCtrl.valueChanges
        .startWith(null)
        .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());

    this.jobsiteCtrl.reset();
    this.jobsiteCtrl.setValue(selected.option.value.Title);
  }


  customerSelected(selected, input) {

    this.selectedJobsiteForInput.CustomerId = selected.option.value.Id
    this.currentSelection.customer.Id = selected.option.value.Id;
    this.currentSelection.customer.Title = selected.option.value.Title;
    //fleet configuration filter
    this.JobSiteforFleetconfiguration.CustomerId = selected.option.value.Id;
    this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);
    this.pushMultipleSelection(1, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);

    this.customerCtrl.reset();
    this.customerCtrl.setValue(selected.option.value.Title)
  }
  resetCustomer(): Customer[] {
    this.currentSelection.customer = new Customer();
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);
    this.jobsiteCtrl.reset();


    if (this.multipleSelections.filter(m => m.Id === 21).length === 0)
      return this.selectionLists.customerList.filter(cust => this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0);

    if (this.multipleSelections.filter(m => m.Id === 21).length > 0)
      return this.selectionLists.customerList.filter(cust =>
        this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);

    return this.selectionLists.customerList.filter(cust =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);


  }
  customerDisplayMapper(customer: Customer) {
    return customer ? customer.Title : customer;
  }
  filterCustomers(userText: any) {
    // console.log('filterCustomers', userText);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.selectionLists.customerList.filter(cust =>
      cust.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
      && (this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr.toLowerCase() === cust.Title.toLowerCase())) < 0)
    );
  }


  pushMultipleSelection(itemId: number, searchId: number, searchText: string): void {

    if ((searchId === 0 && searchText.length === 0))
      return;
    console.log('itemId ' + itemId + '  search Id ' + searchId + ' searvh text ' + searchText)
    const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
    if (!currentSearchItem) return;

    // If the item isn't a date
    if (itemId !== 12 && itemId !== 13 && itemId !== 22 && itemId !== 23) {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId && (m.SearchId === searchId || m.SearchStr.toLowerCase() === searchText.toLowerCase()));
      if (index >= 0 && itemId !== 20) return;
    } else if (itemId == 22) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 22);
    }
    else if (itemId == 23) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 23);
    }
    else {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId);
      this.multipleSelections.splice(index, 1);
    }
    const item = new SearchItem();
    item.Id = itemId; item.SearchId = searchId; item.SearchStr = searchText; item.Title = searchText;

    if (itemId == 1) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 2) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 4) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 5) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    }
    else {
      this.multipleSelections.push(item);
    }


    console.log("this.multiple__", this.multipleSelections, item)
  }

  popMultipleSelection(itemId: number, searchId: number, searchText: string) {
    console.log("searchId", searchId, searchText.length)
    if (searchId === 0 && searchText.length === 0)
      return;
    const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
    if (!currentSearchItem) return;
    const index = this.multipleSelections.findIndex(m => m.Id === itemId && (m.SearchId === searchId || m.SearchStr.toLowerCase() === searchText.toLowerCase()));
    if (index < 0) return;
    this.multipleSelections.splice(index, 1);
    this.resetControlBySearchId(itemId);

  }

  resetControlBySearchId(itemId: number): void {
    switch (itemId) {
      case 1: // 1 -> Customer
        this.customerCtrl.reset();
        this.jobsiteCtrl.reset();
        this.equipmentCtrl.reset();
        break;
      case 2: // 2 -> Jobsite
        this.jobsiteCtrl.reset();
        this.equipmentCtrl.reset();
        // this.filteredEquipments = Observable.of(this.selectionLists.equipmentList);
        break;
      case 3: // 3 -> Equpment
        this.equipmentCtrl.reset();
        //this.filteredEquipments = Observable.of(this.selectionLists.equipmentList);
        break;
      case 4: // 4 -> Family
        this.familyCtrl.reset();
        this.modelCtrl.reset();
        break;
      case 5: // 5 -> Make
        this.makeCtrl.reset();
        this.modelCtrl.reset();
        break;
      case 6: // 6 -> Model
        this.modelCtrl.reset();
        break;
      case 20: // 20 -> Examiner
        //this.examinerCtrl.reset();
        break;
      case 21: // 21 -> Dealer
        this.customerCtrl.reset();
        this.jobsiteCtrl.reset();
        this.equipmentCtrl.reset();
      // this.dealerCtrl.reset();
    }
  }

  resetFamily(): Family[] {
    // console.log('resetFamily', this.selectionLists.familyList);
    this.currentSelection.family = new Family();
    if (!this.selectionLists.familyList) return [];

    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.modelCtrl.reset();
    return this.selectionLists.familyList.filter(family =>
      (this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === family.Id || m.SearchStr.toLowerCase() === family.Title.toLowerCase())) < 0)
    );
  }

  filterFamilies(userText: any) {
    // console.log('filterFamilies', this.selectionLists.familyList);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    return this.selectionLists.familyList.filter(family =>
      (family.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0)
      && (this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === family.Id || m.SearchStr.toLowerCase() === family.Title.toLowerCase())) < 0)
    );
  }

  filterMakes(userText: any) {
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    return this.selectionLists.makeList.filter(make =>
      (make.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0)
      && (this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === make.Id || m.SearchStr.toLowerCase() === make.Title.toLowerCase())) < 0)
    );
  }

  resetFields() {
    this.customerCtrl.reset();
    this.jobsiteCtrl.reset();
    this.makeCtrl.reset();
    this.modelCtrl.reset();
    this.familyCtrl.reset();
    this.unitAuto = '';
    this.multipleSelections = [];
    this.selectedModel = [];
    this.statusId = 0;
    this.IsTableShow = false;
    this._appService.getFamilyList('', '').subscribe(result => {
      this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    });

    this.filteredFamilies =
      this.familyCtrl.valueChanges
        .startWith(null)
        .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());
  }

  UpdateActionStatus(QuoteDetail_Auto: number, statusId: number, value) {
    if (value == 1) {
      this.ActionQuoteCheck.StatusId = statusId;
      this.ActionQuoteCheck.ActionQuoteDetail.push({
        QuoteDetailId: QuoteDetail_Auto
      });
    } else {
      this.ActionQuoteCheck.StatusId = this.StatusIdForMain;
      this.ActionQuoteCheck.ActionQuoteDetail = this.ActionQuoteDetailId;
    }

    if (statusId != 4) {
      this._planerService.getUcPlannerActionStatusUpdate(this.ActionQuoteCheck).subscribe(x => {
        if (x.Status == 1) {
          // this.LoadDataRecommenation();
          this.ActionQuoteCheck = new ActionQuoteCheck();
          this.ActionQuoteDetailId = [];
          this._notify.success("Status Updated successfully");
        }
      })
    }

  }

  onCheckboxChange(checked) {
    if (checked) {

      this.EquipmentQuoteSummaryVm.Data.forEach(x => {
        if (x.IsExpanded) {
          x.UcPlannerTrackQuoteDetail.forEach(element => {
            this.ActionQuoteDetailId.push({
              QuoteDetailId: element.QuoteDetailAuto,
            })
          });
        }
      })
    } else {
      // this.ActionQuoteDetailId = this.ActionQuoteDetailId.filter(
      //   (obj) => obj.QuoteDetailId !== item
      // );
    }
  }
  EquipmentQuoteSummaryVm: EquipmentQuoteSummaryVm;
  LoadEquipmentRecommenation() {
    this.IsTableShow = false;
    this.familyId = 0;
    this.JobsiteId = 0;
    this.make_auto = 0;
    this.CustomerId = 0;

    var CustomerData = this.multipleSelections.find(x => x.Id == 1);
    if (CustomerData != null) {
      if (this.customerCtrl.value != '') {
        this.CustomerId = CustomerData.SearchId;
      }
    }
    var familyData = this.multipleSelections.find(x => x.Id == 4);
    if (familyData != null) {
      if (this.familyCtrl.value != '') {
        this.familyId = familyData.SearchId;
      }
    }

    var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
    if (jobSiteData != null) {
      if (this.jobsiteCtrl.value != '') {
        this.JobsiteId = jobSiteData.SearchId;
      }
    }
    var makeData = this.multipleSelections.find(x => x.Id == 5);
    if (makeData != null) {
      if (this.makeCtrl.value != '') {
        this.make_auto = makeData.SearchId;
      }
    }
    var modelData = this.multipleSelections.filter(x => x.Id == 6);
    if (modelData != null) {
      modelData.forEach(element => {
        this.selectedModel.push(element.SearchId)
      });
    }
    this.FleetTableLoader = true;
    this.UcActionRecommedSearch = new UcActionRecommedSearch();
    this.UcActionRecommedSearch.EquipmentId = null;
    this.UcActionRecommedSearch.CustomerId = this.CustomerId == 0 ? null : this.CustomerId;
    this.UcActionRecommedSearch.FamilyId = this.familyId == 0 ? null : this.familyId;
    this.UcActionRecommedSearch.JobsiteId = this.JobsiteId == 0 ? null : this.JobsiteId;
    this.UcActionRecommedSearch.MakeId = this.make_auto == 0 ? null : this.make_auto;
    this.UcActionRecommedSearch.ModelId = this.selectedModel == null || this.selectedModel.length == 0 ? null : this.selectedModel.join(',');
    this.UcActionRecommedSearch.UnitAuto = this.unitAuto == "" ? null : this.unitAuto;
    this.UcActionRecommedSearch.StatusId = this.statusId == 0 ? null : this.statusId;
    this._planerService.getUcPlannerActionRecommendationEquipment(this.UcActionRecommedSearch).subscribe(result => {
      this.EquipmentQuoteSummaryVm = result;
      if (this.EquipmentQuoteSummaryVm.Data != null) {
        this.EquipmentQuoteSummaryVm.Data.forEach(x => x.IsExpanded = false);

        this.Length = this.EquipmentQuoteSummaryVm.Data.length;
      }

      this.FleetTableLoader = false;
      this.IsTableShow = true;
    })

  }

  toggleExpansion(item: any, value: number) {


    item.IsExpanded = !item.IsExpanded;
    // this.componentLoader = true;
    this.UcActionRecommedSearch = new UcActionRecommedSearch();
    this.UcActionRecommedSearch.EquipmentId = item.EquipmentId;
    this.UcActionRecommedSearch.ActionDate = item.OldestDate;
    this._planerService.getUcPlannerActionRecommendation(this.UcActionRecommedSearch).subscribe(result => {
      this.UcPlannerTrackQuoteDetailVm = result;
      if (this.UcPlannerTrackQuoteDetailVm.Data != null) {
        item.UcPlannerTrackQuoteDetail = this.UcPlannerTrackQuoteDetailVm.Data;
        this.Length = this.UcPlannerTrackQuoteDetailVm.Data.length;
      }
      this.FleetTableLoader = false;
      this.IsTableShow = true;
    })

  }
  NavigateTo(ActionDate: string, smu: number, equipemntId: number,flag?:number) {

    // window.open('/product-improvement-asset/' + this.ImplementId + '/' + Id + '/' + PIPId, '_blank');
   if(flag==1){
    window.open(`/equipment-record-action/${equipemntId}/${smu}?actionDate=${encodeURIComponent(ActionDate.split('T')[0])}`, '_blank');
   }else{
    window.open(`/equipment-action-recommendation/${equipemntId}/${smu}?actionDate=${encodeURIComponent(ActionDate.split('T')[0])}`, '_blank');
   }
  }

  DateChange(Date: string, QuoteDetaiId: number) {

    this._planerService.UpdateTrackQuoteStatusDate(QuoteDetaiId, moment(Date).format('MM/DD/YYYY')).subscribe(res => {
      if (res.StatusId == 1) {
        this._notify.success("Status Updated successfully");
      }
    })
  }

  OnchangeMainStatus(event) {
    this.EquipmentQuoteSummaryVm.Data.forEach(x => {
      if (x.IsExpanded) {
        x.UcPlannerTrackQuoteDetail.forEach(y => {
          y.IsChecked = true;
          this.ActionQuoteDetailId.push({
            QuoteDetailId: y.QuoteDetailAuto,
          })
        })
      }
    });
  }
  StatusIdForMain: number;
  changeStatus() {
    this.EquipmentQuoteSummaryVm.Data.forEach(x => {

      if (x.IsExpanded) {

        x.UcPlannerTrackQuoteDetail.forEach(y => {
          y.StatusId = this.StatusIdForMain;
        })
      }

    });
  }
isPopupOpen:boolean
actionDate: string;smu:number;
equipemntId:number;flag:number;
ActionDateCheck(actionDate: string, smu: number, equipemntId: number,flag?:number){

this.actionDate=actionDate;
this.smu= smu;
this.equipemntId=equipemntId;
this.flag=flag;

const today = new Date();
  const date = new Date(actionDate);
  // Compare only date part (ignore time)
  if(date.setHours(0, 0, 0, 0) > today.setHours(0, 0, 0, 0)){
    this.isPopupOpen= true;
  }else
  {
    this.NavigateTo(actionDate,smu,equipemntId,flag);
    this.isPopupOpen= false;
  }
}

closePopup(){
this.isPopupOpen= false;
}

}
